module.exports = __webpack_public_path__ + "img/deliver1.db79c68e.png";